// ** React Imports
import { useEffect, useState, Fragment, forwardRef } from "react";
import { useTranslation } from "react-i18next";
// ** Third Party Components
import Stepper from "bs-stepper";
import classnames from "classnames";
import { PropTypes } from "prop-types";
// ** Reactstrap Imports
import { Button } from "reactstrap";
import { ArrowLeft, ChevronRight, ArrowRight } from "react-feather";
// ** Styles
import "bs-stepper/dist/css/bs-stepper.min.css";
import "../../../../@core/scss/base/plugins/forms/form-wizard.scss";
import {handleErrorOne} from "@src/redux/action/GlobalAction.js"
const Wizard = forwardRef((props, ref) => {
  // ** Props

  const { t } = useTranslation();
  const {
    type,
    className,
    contentClassName,
    headerClassName,
    steps,
    separator,
    options,
    instance,
    handelSubmit,
    handelCancelVote,
    setActiveIndex,
    activeIndex
  } = props;

  //next content navigation
  const goToNext = () => {
    const stepsInputs = document.getElementsByClassName("VoteFormelement");
    let inputsNames = [];
    let currentIndexInputs = [];
    let canGoNext = false;
   
    for (let i = 0; i < stepsInputs.length; i++) {
      inputsNames[i] = stepsInputs[i].id?.split("-")[2];
    }

    for (let i = 0; i < stepsInputs.length; i++) {
      if (inputsNames[i] == activeIndex) {
        currentIndexInputs.push(stepsInputs[i]);
      }
    }
    canGoNext = currentIndexInputs.map((ele) => ele.checked).some((ele) => ele);
    if (canGoNext) {
      if (activeIndex < steps.length - 1) {
        setActiveIndex(activeIndex + 1);
      }
    }else{
      handleErrorOne("choose at leaste one choice")
    }
  };
  //previous content navigation

  const gotToprevious = () => {
    if (activeIndex > 0) {
      setActiveIndex(activeIndex - 1);
    }
  };
  // ** Vars
  let stepper = null;

  // ** Step change listener on mount
  useEffect(() => {}, []);

  // ** Renders Wizard Header
  const renderHeader = () => {
    return steps
      .sort((a, b) => a.id - b.id)
      .map((step, index) => {
        return (
          <Fragment key={step.id}>
            {index !== 0 && index !== steps.length ? (
              <div className="line">{separator}</div>
            ) : null}
            <div

              className={classnames("step", {
                crossed: activeIndex > index,
                active: index === activeIndex
              })}
              data-target={`#${step.id}`}
            >
              <button
                type="button"
                style={{ display: "flex" }}
                className="step-trigger"
              >
                <span className="bs-stepper-box">
                  {step.icon ? step.icon : index + 1}
                </span>
                <span className="bs-stepper-label">
                  <span
                    className="bs-stepper-title"
                    style={{
                      overflowWrap: "break-word",
                      flexWrap: "wrap",
                      display: "flex",
                      maxWidth: "250px"
                    }}
                  >
                    {step.title}
                  </span>
                  {step.subtitle ? (
                    <span className="bs-stepper-subtitle">{step.subtitle}</span>
                  ) : null}
                </span>
              </button>
            </div>
          </Fragment>
        );
      });
  };

  // ** Renders Wizard Content
  const renderContent = () => {
    return steps.map((step, index) => {
      return (
        <div
          className={classnames("content", {
            [contentClassName]: contentClassName,
            "active dstepper-block": activeIndex === index
          })}
          id={step.id}
          key={step.id}
          style={{ maxWidth: "800px" }}
        >
          {" "}
          <div
            className="d-flex justify-content-between"
            style={{ marginTop: "20px", marginBottom: "25px" }}
          >
            {activeIndex === 0 ? (
              <Button
                color="warning"
                onClick={handelCancelVote}
                className="btn-prev"
                outline
              >
                <ArrowLeft
                  size={14}
                  className="align-middle me-sm-25 me-0"
                ></ArrowLeft>
                <span className="align-middle d-sm-inline-block d-none">
                  {t("Cancel")}
                </span>
              </Button>
            ) : (
              <Button
                color="warning"
                onClick={gotToprevious}
                disabled={activeIndex < 1}
                className="btn-prev"
                outline
              >
                <ArrowLeft
                  size={14}
                  className="align-middle me-sm-25 me-0"
                ></ArrowLeft>
                <span className="align-middle d-sm-inline-block d-none">
                  {t("Previous")}
                </span>
              </Button>
            )}
            {activeIndex < steps.length - 1 ? (
              <Button
        
                disabled={!(steps.length - 1 > activeIndex)}
                onClick={goToNext}
                color="primary"
                className="btn-next"
              >
                <span
                  className="align-middle d-sm-inline-block d-none"
                  onClick={goToNext}
                >
                  {t("Next")}
                </span>
                <ArrowRight
                  size={14}
                  className="align-middle ms-sm-25 ms-0"
                ></ArrowRight>
              </Button>
            ) : (
              <Button
                type="submit"
                onClick={handelSubmit}
                color="success"
                className="btn-next"
              >
                <span
                  className="align-middle d-sm-inline-block d-none"
                  onClick={goToNext}
                >
                  {t("Submit")}
                </span>
                <ArrowRight
                  size={14}
                  className="align-middle ms-sm-25 ms-0"
                ></ArrowRight>
              </Button>
            )}
          </div>
          {step.content}
        </div>
      );
    });
  };

  return (
    <div
      ref={ref}
      className={classnames("bs-stepper", {
        [className]: className,
        vertical: type === "vertical",
        "vertical wizard-modern": type === "modern-vertical",
        "wizard-modern": type === "modern-horizontal"
      })}
    >
      <div
        className={classnames("bs-stepper-header", {
          [headerClassName]: headerClassName
        })}
      >
        {renderHeader()}
      </div>
      <div
        className="bs-stepper-content"
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          backgroundColor: "inherit"
        }}
      >
        {renderContent()}
      </div>
    </div>
  );
});

export default Wizard;
